export default __webpack_public_path__ + "3ca0b5342a32c26345a1ad6dfeca00ea.png";